import { ReactElement, ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'

import {
  PowerCardWrapper,
  PowerCardHeader,
  PowerText,
  ChargePercentageText,
  PowerCardHeaderWrapper,
} from './styles'

interface PowerCardProps {
  loading: boolean
  title: string | ReactNode
  text: string | ReactNode
  charge?: string
  icon: ReactElement
  status: string
}

function PowerCard({
  loading,
  title,
  icon,
  text,
  status,
  charge,
}: PowerCardProps) {
  if (loading) {
    return <Skeleton height={'100%'} borderRadius={8} />
  }

  return (
    <PowerCardWrapper status={status}>
      <PowerCardHeaderWrapper>
        <PowerCardHeader>
          {icon}
          {title}
        </PowerCardHeader>
        {charge && <ChargePercentageText>{charge}</ChargePercentageText>}
      </PowerCardHeaderWrapper>

      <PowerText>{text}</PowerText>
    </PowerCardWrapper>
  )
}

export default PowerCard
